import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TextInput } from '@components';
import { TSDViewGeneralInfoFormValues } from './validateTSDViewGeneralInfoForm';

interface TSDDeclarantInfoProps {
  form: UseFormReturnType<TSDViewGeneralInfoFormValues>;
  disabled: boolean;
}

export const TSDDeclarantInfo: React.FC<TSDDeclarantInfoProps> = ({ form, disabled }) => {
  return (
    <Stack mb="xl">
      <Title order={5} fw={600}>
        Declarant Info
      </Title>

      <Grid>
        <Grid.Col span={4}>
          <TextInput {...form.getInputProps('declarantPerson.identificationNumber')} label="Identification number" disabled={disabled} />
        </Grid.Col>

        <Grid.Col span={4}>
          <TextInput {...form.getInputProps('declarantPerson.name')} label="Name" disabled={disabled} />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={5}>
          <TextInput {...form.getInputProps('declarantPerson.communication.phoneNumber')} label="Communication phone number" disabled={disabled} />
        </Grid.Col>

        <Grid.Col span={5}>
          <TextInput {...form.getInputProps('declarantPerson.communication.eMailAddress')} label="Communication email address" disabled={disabled} />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
